<template>
  <div class="container">
    <div id="header" class="flex flex-row-left  margin-top-20 ">
      <div class="flex-item-center">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="产品尺寸">
            <el-select @clear="handleClear('productSize')" clearable v-model="formInline.productSize" placeholder="请选择" style="width: 200px">
              <el-option
                  v-for="item in productSizeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="产品系列">
            <el-select @clear="handleClear('productType')" clearable v-model="formInline.productType" placeholder="请选择" style="width: 200px">
              <el-option
                  v-for="item in productTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="付款方式">
            <el-select @clear="handleClear('payType')"  clearable v-model="formInline.payType" placeholder="请选择" style="width: 200px">
              <el-option
                  v-for="item in payTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="咨询时间">
            <el-date-picker
                @clear="handleClear('startMonth')"
                value-format="YYYY-MM-DD"
                format="YYYY-MM-DD"
                v-model="formInline.startMonth"
                type="date"
                placeholder="上传时间"
                clearable
            />
            -
            <el-date-picker
                @clear="handleClear('endMonth')"
                value-format="YYYY-MM-DD"
                format="YYYY-MM-DD"
                v-model="formInline.endMonth"
                type="date"
                placeholder="上传时间"
                clearable
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="margin-20-0">
      <div>
        <el-table
            :max-height="dynamicHeight"
            :data="tableData"
            :preserve-expanded-content="true"
            :stripe="true" :border="true"
            :highlight-current-row="true"
            size="default"
        >
          <el-table-column
              label="用户邮箱"
              min-width="80"
              prop="email"
          ></el-table-column>
          <el-table-column
              label="用户姓名"
              min-width="100"
              prop="name"
          ></el-table-column>
          <el-table-column
              label="用户手机号"
              min-width="100"
              prop="phone"
          ></el-table-column>
          <el-table-column
              label="购买数量"
              min-width="100"
              prop="number"
          ></el-table-column>
          <el-table-column
              label="产品尺寸"
              min-width="100"
              prop="productSize"
          ></el-table-column>
          <el-table-column
              label="产品类型"
              min-width="100"
              prop="productType"
          ></el-table-column>
          <el-table-column
              label="付款方式"
              min-width="100"
              prop="payType"
          ></el-table-column>
          <el-table-column
              label="备注"
              min-width="80"
              prop="remark"
          >

            <template #default="scope">

              <el-tooltip
                  :content="scope.row.remark"
                  :raw-content="true"
                  :show-overflow-tooltip="false"
              >
                <span class="ellipsis-fallback">
                {{scope.row.remark}}
              </span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
              label="上传时间"
              min-width="100"
              prop="CreateTime"
          ></el-table-column>
        </el-table>
      </div>
      <div class="flex flex-row-center flex-item-center margin-10-0 pagination">
        <el-pagination v-model:current-page="currentPage"  :page-size="pageSize" :total="pageTotal" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" background layout="total, sizes, prev, pager, next,"  />
      </div>
    </div>

  </div>
</template>
<script>
import {ElForm,ElFormItem,ElButton,ElTable,ElSelect,ElOption, ElTableColumn,ElDatePicker,ElTooltip,ElPagination} from "element-plus";
import {getOrderList} from "@/utils/api";
import DynamicHeightMixin from "../../../public/js/dynamicHeightMixin";

export default {
  name: "shopifyOrder",
  mixins:[DynamicHeightMixin],
  components: {ElForm,ElFormItem,ElButton,ElTable,ElDatePicker,ElTooltip,
    ElSelect,ElOption,
    ElTableColumn,ElPagination},
  data(){
    return{
      formInline:{productSize:"",productType:"",payType:""},
      tableData:[],
      currentPage:1,
      pageTotal:0,
      pageSize:20,
      productSizeList:[
        {label:"43 inch",key:"43 inch",value:"43 inch"},
        {label:"55 inch",key:"55 inch",value:"55 inch"},
        {label:"65 inch",key:"65 inch",value:"65 inch"},
        {label:"75 inch",key:"75 inch",value:"75 inch"},
        {label:"Other,please specify",key:"Other,please specify",value:"Other,please specify"},
      ],
      productTypeList:[
        {label:"Partial Sun Outdoor TV",key:"Partial Sun Outdoor TV",value:"Partial Sun Outdoor TV"},
        {label:"Full Sun Outdoor TV",key:"Full Sun Outdoor TV",value:"Full Sun Outdoor TV"},
        {label:"Kitchen Tv",key:"Kitchen Tv",value:"Kitchen Tv"},
        {label:"Bathroom TV",key:"Bathroom TV",value:"Bathroom TV"},
        {label:"12V RV TV",key:"12V RV TV",value:"12V RV TV"},
        {label:"Portable TV",key:"Portable TV",value:"Portable TV"},
      ],
      payTypeList:[
        {label:"Online Order",key:"Online Order",value:"Online Order"},
        {label:"Offline Payment",key:"Offline Payment",value:"Offline Payment"},
      ]
    }
  },
  beforeMount() {
    this.getOrderList();
  },
  methods:{
    onSubmit(){
      this.PageNumber = 1
      this.getOrderList()
    },
    handleSizeChange(val){
      this.pageSize = val;
      this.getOrderList();
    },
    handleCurrentChange(val){
      this.currentPage = val;
      this.getOrderList();
    },
    getOrderList(){
      this.tableData = []
      getOrderList({...this.formInline,PageSize:this.pageSize,PageNumber:this.currentPage}).then(res=>{
        this.tableData = res.Data.data.map((item)=>{
          return {
            ...item,
            remark:item.remark.replace(/\n/g, "<br>"),
          }
        })
        this.pageTotal = res.Data.count
      }).catch(res=>{
        console.log(res)
      })
    },
    handleClear(key) {
      this.formInline[key] = ''; // 手动设置为空字符串
    }
  }
}
</script>
<style scoped>
.container{
  width: 92%;
  margin:0 auto;
}
::v-deep .container {
  .el-form-item{
    margin-bottom:0!important;
  }
}
::v-deep .el-table .el-table__cell{
  box-sizing: border-box;
  min-width: 0;
  padding: 8px 0;
  position: relative;
  text-align: left;
  text-overflow: ellipsis;
  vertical-align: middle;
  z-index: unset !important;
}
.pagination{
  margin: 20px auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ellipsis-fallback {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}
.tooltip-class .el-tooltip__popper {
  max-width: none !important; /* 确保宽度不受限制 */
}

.tooltip-class .el-tooltip__popper .popper__arrow {
  display: none; /* 隐藏箭头，因为箭头可能会干扰布局 */
}

.tooltip-class .el-tooltip__popper .popper__inner {
  white-space: pre-wrap; /* 允许内容换行 */
  word-break: break-word; /* 在长单词或URL内部进行换行 */
}
</style>